module.exports = __webpack_public_path__ + "static/TangleTower7-b70fc1ab192b6d47465f918a6cdf2424.webp";